<template>
    <section class="expired-account-warning d-flex flex-column align-items-end justify-content-end">
        <span>{{ $t('com.file.account.about-to-expire.title') }}</span>
        <span class="expiry-message">{{ $t('com.file.account.about-to-expire.message', {
            days: remainingDays, date:
            validUntilFormatted }) }}</span>
    </section>
</template>
<script charset="utf-8">
export default {
    name: "AccountAboutToExpire",
    data() {
        return {
        };
    },
    computed: {
        remainingDays() {
            return this.$store.state.userStore.accountDetails.remainingDays;
        },
        validUntilFormatted() {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            const date = new Date(this.$store.state.userStore.accountDetails.validUntil);
            return date.toLocaleDateString(this.$i18n.locale, options);
        }
    }
}
</script>
<style lang="scss" scoped>
.expired-account-warning {
    font-size: 0.8em;
    line-height: 1.3em;
    border: 1px solid red;
    padding: 10px;
    border-radius: 10px;
    background: #fdeeee;

    span {
        font-size: 1em;
    }

    .expiry-message {
        font-weight: bold;
        font-size: 1.4em;
    }
}
</style>